export function highlightText() {
    const goToStack = document.querySelectorAll('a[href^="#"]');
    if (goToStack.length > 0) {
        goToStack.forEach((elem) => {
            elem.addEventListener("click", function (event) {
                const goToId = elem.getAttribute("href");
                const toHighlight = document.querySelector(goToId);
                if (!toHighlight) return;

                toHighlight.style.transition = 'background-color 1s ease-out';
                toHighlight.style.backgroundColor = '#6CDB8B';
                toHighlight.focus && toHighlight.focus();

                setTimeout(() => {
                    toHighlight.style.backgroundColor = "transparent";
                }, 1000);
            });
        });
    }
}
